export const flagIconCss = {
  path: {
    strokeWidth: "3",
  },
};
